// Regular Expressions
export const REGEX_SPECIAL_CHARACTER: RegExp = /^[a-zA-Z0-9]*$/
export const REGEX_SPECIAL_CHARACTER_ALLOWED: RegExp = /^[a-zA-Z0-9@#$%^&.]*$/
export const REGEX_SENDER_NAME: RegExp = /^[A-Za-z *\s]*$/
export const REGEX_EMAIL =
  // eslint-disable-next-line max-len
  /(?=.*^[0-9a-zA-Z@.]+$)(?=.*^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$).*/
export const REGEX_PHONE_NUMBER: RegExp = new RegExp(
  '^(' +
    '086|096|097|098|039|038|037|036|035|034|033|032|' +
    '091|094|088|083|084|085|081|082|' +
    '070|079|077|076|078|089|090|093|' +
    '092|052|056|058|' +
    '099|059|' +
    '087' +
    ')\\d{7}$'
)

export const REGEX_ALPHABET_UNICODE: RegExp = /^[A-Za-z \s]*$/
export const REGEX_NUMBER: RegExp = /^[0-9]*$/
export const REGEX_NO_SPACES = /^\S+$/
